<div fxLayout="row" fxLayoutAlign="flex-start center" class="geolevel-chip">
    <div class="geolevel-arrow">
        <a (click)="onBackClick()">
            <mat-icon>chevron_left</mat-icon>
        </a>
    </div>

    <div class="filter-chip" fxLayout="row">
        @if (selectedState) {
        <p>State: <span class="badge">{{ selectedState }}</span></p>
        }
        @if (selectedDistrict) {
        <p>District: <span class="badge">{{ selectedDistrict }}</span></p>
        }
        @if (selectedBankType) {
        <p>Bank Type: <span class="badge">{{ selectedBankType }}</span></p>
        }
        @if (selectedPromoter) {
        <p>Promoters: <span class="badge">{{ selectedPromoter }}</span></p>
        }
        @if (selectedBankName) {
        <p>Bank Name: <span class="badge">{{ selectedBankName }}</span></p>
        }
        @if (selectedBlock) {
        <p>Block: <span class="badge">{{ selectedBlock }}</span></p>
        }
        @if (selectedPanchayat) {
        <p>Panchayat: <span class="badge">{{ selectedPanchayat }}</span></p>
        }
        @if (selectedVillage) {
        <p>Village: <span class="badge">{{ selectedVillage }}</span></p>
        }
        @if (selectedSHG) {
        <p>SHG: <span class="badge">{{ selectedSHG }}</span></p>
        }
        @if (selectedCLF) {
        <p>CLF: <span class="badge">{{ selectedCLF }}</span></p>
        }
        @if (selectedVO) {
        <p>VO: <span class="badge">{{ selectedVO }}</span></p>
        }
        @if (selectedCadreVertical) {
        <p>Cadre Vertical: <span class="badge">{{ selectedCadreVertical }}</span></p>
        }
    </div>
</div>
